import MarqueePlugin from 'vanilla-marquee';

class Marquee {
  constructor(element) {
    this.element = element;

    this.init();
  }

  init() {
    this.marquee = new MarqueePlugin(this.element, {
      duplicated: true,
      speed: 30,
      delayBeforeStart: 0,
      startVisible: true,
    });
  }

  destroy() {
    this.marquee.destroy();
  }
}

export default Marquee;
